/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const OverflowIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="20px"
      width="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4583 9.99999C11.4583 10.8054 10.8054 11.4583 10 11.4583C9.19465 11.4583 8.54177 10.8054 8.54177 9.99999C8.54177 9.19457 9.19465 8.54166 10 8.54166C10.8054 8.54166 11.4583 9.19457 11.4583 9.99999ZM6.87511 10C6.87511 10.8054 6.22223 11.4583 5.41686 11.4583C4.6115 11.4583 3.95862 10.8054 3.95862 10C3.95862 9.1946 4.6115 8.54168 5.41686 8.54168C6.22223 8.54168 6.87511 9.1946 6.87511 10ZM14.5831 11.4583C15.3885 11.4583 16.0414 10.8054 16.0414 9.99999C16.0414 9.19457 15.3885 8.54166 14.5831 8.54166C13.7778 8.54166 13.1249 9.19457 13.1249 9.99999C13.1249 10.8054 13.7778 11.4583 14.5831 11.4583Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
